// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../../config";
// import "./AdminLogin.css";
// const AdminLogin = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     try {
//       const response = await fetch(`${API}/auth/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       const resData = await response.json();

//       if (!response.ok) {
//         throw new Error(resData.message || "Invalid credentials");
//       }

//       const { user, token } = resData.data;

//       if (user.role !== "ADMIN") {
//         throw new Error("Access Denied: You do not have administrator privileges.");
//       }
//       localStorage.setItem("adminToken", token);
//       localStorage.setItem("adminUser", JSON.stringify(user));
//       navigate("/admin/dashboard");
//     } catch (err) {
//       setError(err.message || "Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="admin-login-container">
//       <div className="celestial-bg"></div>
//       <div className="login-card-wrapper">
//         <div className="login-card">
//           <div className="login-logo">
//             <span className="logo-symbol">✦</span>
//             <h2>Rudraksha Admin</h2>
//             <p>Enter your credentials to access the celestial panel</p>
//           </div>
//           {error && <div className="error-alert">{error}</div>}
//           <form onSubmit={handleLogin} className="login-form">
//             <div className="form-group">
//               <label htmlFor="email">Email Address</label>
//               <input
//                 id="email"
//                 type="email"
//                 placeholder="vickeyadmin@gmail.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//                 autoComplete="email"
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <input
//                 id="password"
//                 type="password"
//                 placeholder="••••••••"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//                 autoComplete="current-password"
//               />
//             </div>

//             <button type="submit" className="login-btn" disabled={loading}>
//               {loading ? <span className="spinner"></span> : "Unlock Dashboard"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLogin;

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API from "../../config";
// import "./AdminLogin.css";

// const AdminLogin = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");

//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const handleLogin = async (e) => {
//     e.preventDefault();

//     setError("");

//     if (!email || !password) {
//       setError("Please enter email and password.");
//       return;
//     }

//     setLoading(true);

//     try {
//       // Exact API URL
//       const loginUrl = `${API}/auth/login`;
//       console.log("Login API URL:", loginUrl);

//       const response = await fetch(loginUrl, {
//         method: "POST",

//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },

//         body: JSON.stringify({
//           email: email.trim(),
//           password: password,
//         }),
//       });

//       console.log("Status:", response.status);

//       // Response JSON
//       const resData = await response.json();

//       console.log("Login Response:", resData);

//       // API error
//       if (!response.ok) {
//         throw new Error(
//           resData?.message || resData?.error || "Invalid email or password.",
//         );
//       }

      
//       /*
//         API response generally can be:

//         {
//           data: {
//             user: {...},
//             token: "xxxxx"
//           }
//         }

//         OR

//         {
//           user: {...},
//           token: "xxxxx"
//         }
//       */

//       const data = resData?.data || resData;

//       const token = data?.token || resData?.token || resData?.accessToken;

//       const user = data?.user || resData?.user;

//       console.log("Token:", token);
//       console.log("User:", user);

//       // Token not received
//       if (!token) {
//         throw new Error(
//           "Login successful, but authentication token was not received.",
//         );
//       }

//       // Save token
//       localStorage.setItem("adminToken", token);
//       localStorage.setItem("token", token);

//       // Save user if API sends user
//       if (user) {
//         localStorage.setItem("adminUser", JSON.stringify(user));
//       }

//       /*
//         ADMIN ROLE CHECK

//         Agar API user ke andar role bhejti hai,
//         tab ADMIN check hoga.

//         Agar role nahi bheja gaya,
//         login ko block nahi karenge.
//       */

//       if (user?.role && String(user.role).toUpperCase() !== "ADMIN") {
//         localStorage.removeItem("adminToken");
//         localStorage.removeItem("token");
//         localStorage.removeItem("adminUser");

//         throw new Error(
//           "Access Denied: You do not have administrator privileges.",
//         );
//       }

//       // Login successful
//       console.log("Admin login successful!");

//       // Dashboard redirect
//       navigate("/admin/dashboard");
//     } catch (err) {
//       console.error("LOGIN ERROR:", err);

//       setError(err?.message || "Something went wrong. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="admin-login-container">
//       {/* Background */}
//       <div className="celestial-bg"></div>

//       <div className="login-card-wrapper">
//         <div className="login-card">
//           {/* Logo */}
//           <div className="login-logo">
//             <h2>Rudraksha Admin</h2>
//             <div className="about-heading-line">
//               <img
//                 src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
//                 alt="Heading decoration"
//               />
//             </div>
//             <br />
//             <p>Enter your credentials to access the celestial panel</p>
//           </div>

//           {/* Error */}
//           {error && <div className="error-alert">{error}</div>}

//           {/* Form */}
//           <form onSubmit={handleLogin} className="login-form">
//             {/* Email */}
//             <div className="form-group">
//               <label htmlFor="email">Email Address</label>

//               <input
//                 id="email"
//                 type="email"
//                 placeholder="astrouser@example.com"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 autoComplete="email"
//                 required
//               />
//             </div>

//             {/* Password */}
//             <div className="form-group">
//               <label htmlFor="password">Password</label>

//               <input
//                 id="password"
//                 type="password"
//                 placeholder="Enter password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 autoComplete="current-password"
//                 required
//               />
//             </div>

//             {/* Login Button */}
//             <button type="submit" className="login-btn" disabled={loading}>
//               {loading ? (
//                 <>
//                   <span className="spinner"></span>
//                   Logging in...
//                 </>
//               ) : (
//                 "Login"
//               )}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminLogin;













import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../config";
import "./AdminLogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    setError("");

    // ==============================
    // BASIC VALIDATION
    // ==============================

    if (!email.trim() || !password.trim()) {
      setError("Please enter email and password.");
      return;
    }

    setLoading(true);

    try {
      // ==============================
      // LOGIN API
      // ==============================

      const loginUrl = `${API}/auth/login`;

      console.log("Login API URL:", loginUrl);

      const response = await fetch(loginUrl, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },

        body: JSON.stringify({
          email: email.trim(),
          password: password,
        }),
      });

      console.log("Login Status:", response.status);

      // ==============================
      // RESPONSE
      // ==============================

      const resData = await response.json();

      console.log("Login Response:", resData);

      if (!response.ok) {
        throw new Error(
          resData?.message ||
            resData?.error ||
            "Invalid email or password."
        );
      }

      // ==============================
      // GET DATA
      // ==============================

      const data = resData?.data || resData;

      const token =
        data?.token ||
        resData?.token ||
        data?.accessToken ||
        resData?.accessToken;

      const user =
        data?.user ||
        resData?.user ||
        null;

      console.log("LOGIN TOKEN:", token);
      console.log("LOGIN USER:", user);

      // ==============================
      // TOKEN CHECK
      // ==============================

      if (!token) {
        throw new Error(
          "Login successful, but authentication token was not received."
        );
      }

      // ==============================
      // SAVE TOKEN
      // IMPORTANT FOR ADDRESS API
      // ==============================

      localStorage.setItem("token", token);

      localStorage.setItem("accessToken", token);

      // Admin ke liye bhi token save
      localStorage.setItem("adminToken", token);

      console.log("TOKEN SAVED SUCCESSFULLY");

      // ==============================
      // SAVE USER
      // ==============================

      if (user) {
        localStorage.setItem(
          "user",
          JSON.stringify(user)
        );

        localStorage.setItem(
          "adminUser",
          JSON.stringify(user)
        );
      }

      // ==============================
      // GET ROLE
      // ==============================

      const role = String(
        user?.role || ""
      ).toUpperCase();

      console.log("USER ROLE:", role);

      // ==============================
      // ADMIN LOGIN
      // ==============================

      if (role === "ADMIN") {
        console.log("ADMIN LOGIN SUCCESS");

        navigate("/admin/dashboard");

        return;
      }

      // ==============================
      // NORMAL USER LOGIN
      // ==============================

      if (role === "USER") {
        console.log("USER LOGIN SUCCESS");

        navigate("/account");

        return;
      }

      // ==============================
      // ROLE NOT FOUND
      // ==============================

      console.log(
        "Login successful but role was not returned."
      );

      navigate("/account");
    } catch (err) {
      console.error("LOGIN ERROR:", err);

      // Error ke time token remove
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("adminToken");

      setError(
        err?.message ||
          "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">

      {/* BACKGROUND */}
      <div className="celestial-bg"></div>

      <div className="login-card-wrapper">

        <div className="login-card">

          {/* =========================
              LOGO / HEADING
          ========================= */}

          <div className="login-logo">

            <h2>Rudraksha Login</h2>

            <div className="about-heading-line">
              <img
                src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
                alt="Heading decoration"
              />
            </div>

            <br />

            <p>
              Enter your credentials to continue
            </p>

          </div>

          {/* =========================
              ERROR
          ========================= */}

          {error && (
            <div className="error-alert">
              {error}
            </div>
          )}

          {/* =========================
              LOGIN FORM
          ========================= */}

          <form
            onSubmit={handleLogin}
            className="login-form"
          >

            {/* EMAIL */}

            <div className="form-group">

              <label htmlFor="email">
                Email Address
              </label>

              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) =>
                  setEmail(e.target.value)
                }
                autoComplete="email"
                required
              />

            </div>

            {/* PASSWORD */}

            <div className="form-group">

              <label htmlFor="password">
                Password
              </label>

              <input
                id="password"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value)
                }
                autoComplete="current-password"
                required
              />

            </div>

            {/* LOGIN BUTTON */}

            <button
              type="submit"
              className="login-btn"
              disabled={loading}
            >

              {loading ? (
                <>
                  <span className="spinner"></span>

                  Logging in...
                </>
              ) : (
                "Login"
              )}

            </button>

          </form>

        </div>

      </div>

    </div>
  );
};

export default AdminLogin;